/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, ReactNode } from "react";
import { LoadScript } from "@react-google-maps/api";
import { useTranslation } from "react-i18next";

// Google Maps API key from environment variable
const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

interface GoogleMapsContextValue {
  isLoaded: boolean;
}

const GoogleMapsContext = createContext<GoogleMapsContextValue>({ isLoaded: false });

export const useGoogleMaps = () => useContext(GoogleMapsContext);

interface GoogleMapsProviderProps {
  children: ReactNode;
}

export function GoogleMapsProvider({ children }: GoogleMapsProviderProps) {
  const { t } = useTranslation();

  if (!GOOGLE_MAPS_API_KEY) {
    // If no API key, just render children without LoadScript
    return <>{children}</>;
  }

  return (
    <LoadScript 
      googleMapsApiKey={GOOGLE_MAPS_API_KEY}
      loadingElement={<div>{t("maps.loading")}</div>}
    >
      <GoogleMapsContext.Provider value={{ isLoaded: true }}>
        {children}
      </GoogleMapsContext.Provider>
    </LoadScript>
  );
}
